import { Injectable } from "@angular/core";
import { removeAccents } from "@obg/ngx.common";
import { toGreeklish } from "@obg/ngx.ui.common";

@Injectable({
	providedIn: "root",
})
export class UppercaseInputValueService {
	transform(
		value: string,
		options?: { isHgcRulesEnabled?: boolean; isSeparateNamesByHyphenRuleEnabled?: boolean }
	): string {
		if (!value) {
			throw new Error("Value must be truthy!");
		}

		if (options?.isHgcRulesEnabled) {
			return this.hgcRules(value);
		}

		if (options?.isSeparateNamesByHyphenRuleEnabled) {
			return this.separateNamesByHyphenRule(value);
		}
		const removeAccent = removeAccents(value);

		return removeAccent.toUpperCase();
	}

	private hgcRules(value: string): string {
		const valueToGreeklish = toGreeklish(value);
		const separateNamesByHyphen = this.separateNamesByHyphenRule(valueToGreeklish);

		return separateNamesByHyphen;
	}

	private separateNamesByHyphenRule(value: string): string {
		return value.toUpperCase().replace(/[\s-]+/g, "-");
	}
}
